export const version = '1.8.0-next.17'
